export default __webpack_public_path__ + "static/media/sensor.68464925.svg";